<template>
  <div class="stepper" role="tablist">
    <template v-for="(s, i) in steps" :key="s.id">
      <button
        type="button"
        class="stepper-item"
        :class="[stateFor(i), { clickable: clickableFor(i) }]"
        :disabled="!clickableFor(i)"
        :aria-selected="i === idx"
        role="tab"
        @click="onClick(i)"
      >
        <span class="stepper-dot">
          <LtIcon v-if="stateFor(i) === 'done'" name="check" :size="14" />
          <template v-else>{{ i + 1 }}</template>
        </span>
        <span class="stepper-label">
          <span class="stepper-label-num">שלב {{ i + 1 }}</span>
          <span class="stepper-label-title">{{ s.title }}</span>
        </span>
      </button>
      <span v-if="i < total - 1" class="stepper-line" :class="{ done: i < idx }"></span>
    </template>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';
import { STEPS } from './data.js';

export default {
  name: 'SignupStepper',
  components: { LtIcon },
  props: {
    idx:        { type: Number, required: true },
    total:      { type: Number, required: true },
    maxReached: { type: Number, required: true },
  },
  emits: ['go-to'],
  computed: {
    steps() { return STEPS; },
  },
  methods: {
    stateFor(i) {
      if (i < this.idx) return 'done';
      if (i === this.idx) return 'current';
      return 'upcoming';
    },
    clickableFor(i) { return i <= this.maxReached; },
    onClick(i) {
      if (this.clickableFor(i)) this.$emit('go-to', i);
    },
  },
}
</script>
